export const iconFontAwesomeMapsBagShopping = (
	<i className="fa-solid fa-bag-shopping"></i>
);
